(function () {
  function initProjectorMenus (root) {
    root.querySelectorAll('.megamenu-projectors-custom').forEach(function (menu) {
      if (menu.dataset.projectorReady === 'true') return
      menu.dataset.projectorReady = 'true'

      const categories = Array.from(menu.querySelectorAll('[data-projector-category]'))
      const panels = Array.from(menu.querySelectorAll('[data-projector-panel]'))

      function showCategory (id) {
        categories.forEach(function (category) {
          const active = category.dataset.projectorCategory === id
          category.classList.toggle('is-active', active)
          category.setAttribute('aria-expanded', String(active))
        })
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.projectorPanel !== id
        })
      }

      categories.forEach(function (category) {
        category.addEventListener('mouseenter', function () {
          showCategory(category.dataset.projectorCategory)
        })
        category.addEventListener('focus', function () {
          showCategory(category.dataset.projectorCategory)
        })
        category.addEventListener('click', function () {
          showCategory(category.dataset.projectorCategory)
        })
      })
    })

    root.querySelectorAll('.projector-mobile-menu').forEach(function (menu) {
      if (menu.dataset.projectorReady === 'true') return
      menu.dataset.projectorReady = 'true'

      const categories = menu.querySelector('.projector-mobile-categories')
      const panels = Array.from(menu.querySelectorAll('[data-projector-mobile-panel]'))

      function showPanel (id) {
        categories.hidden = Boolean(id)
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.projectorMobilePanel !== id
        })
      }

      menu.addEventListener('click', function (event) {
        const category = event.target.closest('[data-projector-mobile-category]')
        if (category) {
          showPanel(category.dataset.projectorMobileCategory)
          return
        }
        if (event.target.closest('[data-projector-mobile-back]')) showPanel(null)
      })

      const drawer = menu.closest('.mobile-main-menu')
      if (drawer) {
        const close = drawer.querySelector('.icon-close-wrap')
        if (close) close.addEventListener('click', function () { showPanel(null) })
        const trigger = menu.previousElementSibling
        if (trigger) {
          trigger.addEventListener('click', function () { showPanel(null) })
        }
      }
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initProjectorMenus(document) })
  } else {
    initProjectorMenus(document)
  }
  document.addEventListener('shopify:section:load', function (event) { initProjectorMenus(event.target) })
})()
